/**
 * The public marketing origin, when this deployment has one.
 *
 * The console and the website are separate applications on separate origins, so a document that
 * lives on one cannot be reached from the other by a relative href. Hard-coding an origin would
 * be worse than not linking at all: it would render a link to somebody else's domain, or to a
 * domain that does not exist yet, on the one screen where a person is about to hand over their
 * work address.
 *
 * So the origin is configuration. Set `VITE_PUBLIC_SITE_URL` and the small print's documents —
 * and the sign-up line, which points at the site's own "Get started" — become links; leave it
 * unset and the same names render as plain text. Both are honest. A dead link is not.
 *
 * The value is read per call rather than captured at module load. Vite inlines it either way, so
 * the built bundle is identical; reading it late is what lets a test stub the variable and see
 * both states without a second module graph.
 */
function siteOrigin(): string | null {
	const raw = import.meta.env.VITE_PUBLIC_SITE_URL
	return typeof raw === 'string' && raw.trim() !== '' ? raw.trim().replace(/\/+$/, '') : null
}

/** An absolute URL on the public site, or null when this deployment has none configured. */
export function publicSiteHref(path: string): string | null {
	const origin = siteOrigin()
	if (!origin) return null
	return `${origin}${path.startsWith('/') ? path : `/${path}`}`
}
